import styled from "styled-components";

export const Content = styled.div`
  width: 100%;

  h1 {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 24px;
  }

  h2 {
    font-size: 20px;
    font-weight: 600;
  }

  h3 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 8px;
    line-height: 120%;
  }

  p {
    font-size: 16px;
    line-height: 160%;
    margin-bottom: 16px;
    color: #4d4d4d;
  }
`;
